import api from './api'

export const employeeService = {
  // Get all employees
  getAllEmployees: async () => {
    const response = await api.get('/employees')
    return response.data
  },

  // Get active employees only (for team directory)
  getActiveEmployees: async () => {
    const response = await api.get('/employees/active')
    return response.data
  },

  // Get employee by ID
  getEmployeeById: async (id) => {
    const response = await api.get(`/employees/${id}`)
    return response.data
  },

  // Create new employee
  createEmployee: async (employeeData) => {
    const response = await api.post('/employees', employeeData)
    return response.data
  },

  // Get employee password (HR/Admin only)
  getEmployeePassword: async (id) => {
    const response = await api.get(`/employees/${id}/password`)
    return response.data
  },

  // Resend invitation email (HR/Admin only)
  resendInvitation: async (id) => {
    const response = await api.post(`/employees/${id}/resend-invitation`)
    return response.data
  },

  // Get my profile
  getMyProfile: async () => {
    const response = await api.get('/employees/profile')
    return response.data
  },

  // Update my profile
  updateMyProfile: async (profileData) => {
    const response = await api.put('/employees/profile', profileData)
    return response.data
  },

  // Get today's birthdays
  getTodaysBirthdays: async () => {
    const response = await api.get('/employees/birthdays/today')
    return response.data
  },

  // Update employee (Admin/HR only)
  updateEmployee: async (id, employeeData) => {
    const response = await api.put(`/employees/${id}`, employeeData)
    return response.data
  },

  // Update employee status (Admin/HR only)
  updateEmployeeStatus: async (id, status) => {
    const response = await api.put(`/employees/${id}/status`, { status })
    return response.data
  },

  // Delete employee (Admin/HR only)
  deleteEmployee: async (id) => {
    const response = await api.delete(`/employees/${id}`)
    return response.data
  }
}
